import { render, staticRenderFns } from "./FeaturesList.vue?vue&type=template&id=1493f7a8&scoped=true&"
import script from "./FeaturesList.vue?vue&type=script&lang=ts&"
export * from "./FeaturesList.vue?vue&type=script&lang=ts&"
import style0 from "./FeaturesList.vue?vue&type=style&index=0&id=1493f7a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1493f7a8",
  null
  
)

export default component.exports